import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, Dialog, CardHeader, Drawer, FormControl, FormLabel, FormControlLabel, Radio, RadioGroup, TextField, Button, InputAdornment, CircularProgress, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import { index } from '../../../store/actions/transaction.action'
import { changeScreen, changeScreenB, changeScreenC } from '../../../store/actions/navigation.action'
import { MdKeyboardBackspace, MdDelete } from 'react-icons/md'
import { FaDownload } from "react-icons/fa"
import { FcFilingCabinet } from 'react-icons/fc'
import MaskedInput from 'react-text-mask'
import { SCROLL } from '../../../config/App'
import Detail from './detail'
import VerifySms from '../../components/VerifySms'

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [];

    if (props.name === 'money') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/]
        if (other.value) {
            if (other.value.length > 2) {
                mask = [/[0-9]/, '.', /\d/, /\d/, /\d/, /\d/]
            }
            if (other.value.length > 4) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/]
            }
            if (other.value.length > 5) {
                mask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/]
            }
        }
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

export default function Transactions(props) {
    const dispatch = useDispatch()
    const user_id = (props.user_id) ? props.user_id : null
    const { open, screen_id } = useSelector(state => state.smsReducer)
    const { transactions } = useSelector(state => user_id ? state.transactionReducer.user : state.transactionReducer)
    const action_id = (props.uid) ? props.uid : null
    const link_id = (props.link_id) ? props.link_id : null
    const screen = (props.screen) ? props.screen : null

    const [isLoading, setLoading] = React.useState(true)
    const [ isLoadMore, setLoadMore ] = React.useState(false)
    const [ isSort, setSort ] = React.useState(false)

    const [isMenu, setMenu] = React.useState(false)
    const date = new Date()
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [dateInitial, setDateInitial] = React.useState(user_id ? null : dateInit)
    const [dateFinal, setDateFinal] = React.useState(user_id ? null : dateEnd)

    const [form, setForm] = React.useState({
        status: 'aprovado',
        amount: null,
        order: 'bigger'
    });

    const [detail, setDetail] = React.useState({
        id: null,
        open: false
    })

    React.useEffect(() => {
        _index()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [query, setQuery] = React.useState({
        page: 1,
        initial: dateInitial ? new Date(dateInitial) : null,
        final: dateFinal ? new Date(dateFinal) : null,
        amount: document.getElementById('amount') ? document.getElementById('amount').value : null,
        order: form.order,
        status: form.status,
        user_id: user_id,
        link_id: link_id
    })
    
    React.useEffect(() => {
        document.getElementById("scroll").addEventListener('scroll', _handleScroll)
        return () => document.getElementById("scroll") && document.getElementById("scroll").removeEventListener('scroll', _handleScroll)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    })

    React.useEffect(() => {
        if(!isLoading && _index(isLoadMore));
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    React.useEffect(() => {
        if(isLoadMore) {
            setQuery({
                ...query,
                page: query.page + 1,
                initial: dateInitial ? new Date(dateInitial) : null,
                final: dateFinal ? new Date(dateFinal) : null,
                amount: form.amount,
                order: form.order,
                status: form.status,
                user_id: user_id,
                link_id: link_id
            })
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadMore])

    const _handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.srcElement
        let scroll = scrollHeight - (clientHeight + scrollTop)
        if(scroll < SCROLL) {
            if(!isLoadMore && _handleLoadMore());
        }
    }

    const _handleLoadMore = () => {
        if(transactions.current_page < transactions.last_page) {
            setLoadMore(true)
        }
    }

    const _index = (loadMore) => {
        dispatch(index(action_id, query, loadMore)).then(res => {
            setLoading(false)
            setLoadMore(false)
        })
    }

    const _filter = (sort = null) => {
        setMenu(false)
        setLoading(true)
        dispatch(index(action_id, {
            ...query,
            initial: dateInitial ? new Date(dateInitial) : null,
            final: dateFinal ? new Date(dateFinal) : null,
            amount: document.getElementById('amount') ? document.getElementById('amount').value : null,
            order: form.order,
            status: form.status,
            user_id: user_id,
            link_id: link_id,
            sort: sort
        }))
        .then(res => {
            setLoading(false)
            setLoadMore(false)
            if(sort ? setSort(true) : setSort(false));
        })
        
    }

    const _detail = (id) => {
        setDetail({
            id: id,
            open: true
        })
    }

    return (
        <>  
            <VerifySms 
                type="login_code"
                open={screen_id === 'transactions.index' && open}
                onConfirm={() => {
                    if(!isLoadMore) {
                        setLoading(true)
                    }
                    
                    _index(isLoadMore)
                }}
                onClose={() => (link_id || user_id) ? (screen === 'c' ? dispatch(changeScreenC({ open: false })) : dispatch(changeScreenB({ open: false }))) : dispatch(changeScreen({ open: false }))}
            />

            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => {
                        (link_id || user_id) ? (screen === 'c' ? dispatch(changeScreenC({ open: false })) : dispatch(changeScreenB({ open: false }))) : dispatch(changeScreen({ open: false }))}
                     } 
                     edge="start" 
                     color="inherit"
                     >
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Transações</Typography>
                    
                    <Button onClick={() => setMenu(true)} color="inherit" className="ms-auto">
                        Filtrar
                    </Button>
                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
				style={{width: '100%'}}
                onClose={() => setDetail({ id: null, open: false })}
                className="center"
            >   
                <Detail uid={detail.id} user_id={user_id} onClose={() => setDetail({ id: null, open: false })}/>
            </Dialog>

            <div id="scroll" className="app-bar bg-clear">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <Drawer 
                        anchor="bottom"
                        open={isMenu}
                        onClose={() => setMenu(false)}
                    >
                        <div className="card card-body bs-bg">
                            <div className="mb-3">
                                <FormControl component="fieldset">
                                    <FormLabel className="bs-color" component="legend">Filtrar transações:</FormLabel>
                                    <RadioGroup
                                        name="order"
                                        value={form.status}
                                        onChange={ e => setForm({...form, status: e.target.value})}
                                        className="fw-normal bs-color-b"
                                    >
                                        <FormControlLabel value="aprovado" control={<Radio color="primary" />} label="Aprovado" />
                                        <FormControlLabel value="pendente" control={<Radio color="primary" />} label="Pendente" />
                                        <FormControlLabel value="cancelada" control={<Radio color="primary" />} label="Cancelado" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            
                            <div className="row mt-3">
                                <div className="col-6">
                                    <div className="date mb-3">
                                        <label className="label-date bs-color-b">
                                            {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateInitial))}&nbsp;&nbsp;&nbsp;
                                            {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateInitial))}    
                                        </label>
                                        <TextField
                                            id="datetime-local"
                                            label="Data Inicial"
                                            type="datetime-local"
                                            className="adornedEnd-p-0"
                                            defaultValue={dateInitial ? dateInitial : dateInit}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment className="pointer" position="end">
                                                        {dateInitial ?
                                                        <IconButton className="bs-color" onClick={() => setDateInitial(null)}>
                                                            <MdDelete size={18} />
                                                        </IconButton>
                                                        :
                                                        <></>
                                                        }
                                                    </InputAdornment>
                                                )
                                            }}
                                            onBlur={e => {
                                                if(e.target.value) {
                                                    setDateInitial(e.target.value)
                                                } else {
                                                    setDateInitial(dateInit)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="date mb-3">
                                        <label className="label-date bs-color-b">
                                            {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateFinal))}&nbsp;&nbsp;&nbsp;
                                            {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateFinal))}    
                                        </label>
                                        <TextField
                                            id="datetime-local"
                                            label="Data Final"
                                            type="datetime-local"
                                            className="adornedEnd-p-0"
                                            defaultValue={dateFinal ? dateFinal : dateEnd}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment className="pointer" position="end">
                                                        {dateFinal ?
                                                        <IconButton className="bs-color" onClick={() => setDateFinal(null)}>
                                                            <MdDelete size={18} />
                                                        </IconButton>
                                                        :
                                                        <></>
                                                        }
                                                    </InputAdornment>
                                                )
                                            }}
                                            onBlur={e => {
                                                if(e.target.value) {
                                                    setDateFinal(e.target.value)
                                                } else {
                                                    setDateFinal(dateEnd)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="mb-3">
                                        <label className="label-custom bs-color-b">VALOR</label>
                                        <TextField
                                            id="amount"
                                            name="money"
                                            placeholder="0.00"
                                            type="tel"
                                            InputProps={{
                                                inputComponent: TextMaskCustom,
                                                value: form.amount || '',
                                                onChange: text => {
                                                    setForm({...form, amount: text.target.value.replace(',', '.')})
                                                    setTimeout(() => {
                                                        setForm({...form, amount: document.getElementById('amount') ? document.getElementById('amount').value : null})
                                                    },1000);
                                                },
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <strong>R$</strong>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </div>
                                </div>
                                
                                {(form.amount) &&
                                <div className="col-12 mt-3 mb-3">
                                    <FormControl className="w-100" component="fieldset">
                                        <FormLabel className="bs-color" component="legend">Filtrar por valor</FormLabel>
                                        <RadioGroup
                                            row
                                            name="order"
                                            value={form.order}
                                            onChange={ e => setForm({...form, order: e.target.value})}
                                            className="d-flex justify-content-between fw-bold bs-color-b"
                                        >
                                            <FormControlLabel disabled={(!form.amount)} value="exactly" control={<Radio color="primary" />} label="Exato" />
                                            <FormControlLabel disabled={(!form.amount)} value="bigger" control={<Radio color="primary" />} label="Maior" />
                                            <FormControlLabel disabled={(!form.amount)} value="smaller" control={<Radio color="primary" />} label="Menor" />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                }

                                {(form.amount && form.order === 'bigger' && form.status === 'aprovado' && !user_id) &&
                                    <div className="alert alert-warning mt-3" role="alert">
                                        <strong>Sortear:</strong> O sistema vai escolher uma transação de forma aleatória com base nos Filtros acima.
                                    </div>
                                }

                                <div className="col-12 mt-3 mb-2">
                                    <div className="mb-3">
                                        <Button 
                                            fullWidth
                                            variant="contained" 
                                            color="primary"
                                            size="large"
                                            onClick={() => _filter()}
                                        >
                                            Filtrar
                                        </Button>
                                    </div>
                                    {(form.amount && form.order === 'bigger' && form.status === 'aprovado' && !user_id) &&
                                    <Button
                                        disabled={(form.amount && form.order === 'bigger') ? false : true}
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        size="large"
                                        onClick={() => _filter(true)}
                                    >
                                        Sortear
                                    </Button>
                                    }
                                </div>
                            </div>
                        </div>
                    </Drawer>

                    {(transactions.data.length < 1) &&
                        <div className="card card-body bs-bg mt-3">
                            <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                <FcFilingCabinet size="70" />
                                <h6 className="mt-4 text-muted bs-color">Nenhum registro encontrado</h6>
                            </div>
                        </div>
                    }

                    {(transactions.data.length > 0) &&
                        <>
                        
                        <div className="card-body">
                            <label className="label-custom m-0 bs-color">{transactions.total.toLocaleString('pt-BR', {style: 'decimal'})} registro(s)</label>
                        </div>

                        {isSort &&
                            <div className="card-body pt-0 pb-0">
                                <div className="alert alert-success" role="alert">
                                    <strong>Transação Sorteada</strong> 
                                </div>
                            </div>
                        }

                            {transactions.data.map((item, index) => (
                                <div className="card bs-bg list-items" onClick={() => _detail(item.id)}>
                                    <CardHeader 
                                        avatar={
                                            <Avatar>
                                                <FaDownload />
                                            </Avatar>
                                        }
                                        title={
                                            <>
                                            {(item.status === '1' || item.status === 'approved' || item.status === 'paid') &&
                                                <span className={'fw-bold text-success'}>Aprovado</span>
                                            }
                                            {(item.status === 'cancelled') &&
                                                <span className={'fw-bold text-danger'}>Cancelado</span>
                                            }
                                            {(item.status === 'rejected') &&
                                                <span className={'fw-bold text-danger'}>Rejeitado</span>
                                            }
                                            {(item.status === 'refunded') &&
                                                <span className={'fw-bold text-warning'}>Devolvido</span>
                                            }
                                            {(item.status === 'in_process') &&
                                                <span className={'fw-bold text-warning'}>Em analise</span>
                                            }
                                            {(item.status === 'in_mediation') &&
                                                <span className={'fw-bold text-warning'}>Em disputa</span>
                                            }
                                            {(!item.status || item.status === 'pending') &&
                                                <span className={'fw-bold text-warning'}>Pendente</span>
                                            }
                                            </>
                                        }
                                        subheader={<>
                                            <span className="d-block bs-color">{new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(item.updated_at ? item.updated_at : item.created_at)) + ' as ' + new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(item.updated_at ? item.updated_at : item.created_at))}</span>
                                            {item.user_name &&
                                                <span className="d-block bs-color-b">{item.user_name.name ? item.user_name.name.substring(0,25) : item.user_name.name}</span>
                                            }
                                        </>}
                                        
                                        action={<label className="fw-bold p-3 bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.transaction_amount)}</label>}
                                    />
                                </div>
                            ))}
                        </>
                    }

                    {(isLoadMore) && <div className="text-center card-body"><CircularProgress /></div>}
                </>
            }
            </div>
        </>
    )
}